import { useHandleToast } from "hooks/useHandleToast"

export const useResponseAction = (trafficMail, downloadTraffic) => {
  useHandleToast({
    sucessCondition: trafficMail.data && !trafficMail.loading,
    errorCondition: trafficMail.erros && !trafficMail.loading,
    sucessMsg:
      "Cliente, o seu detalhamento foi enviado por e-mail com sucesso!",
    errorMsg:
      "Cliente, ocorreu um erro ao enviar o seu detalhamento por e-mail! Tente novamente dentro de alguns minutos."
  })

  useHandleToast({
    sucessCondition: downloadTraffic.data && !downloadTraffic.loading,
    erororCondition: downloadTraffic.erros && !downloadTraffic.loading,
    sucessMsg: "Cliente, o seu detalhamento foi baixado com sucesso!",
    errorMsg:
      "Cliente, ocorreu um erro em  seu download! Tente novamente dentro de alguns minutos."
  })
}



// WEBPACK FOOTER //
// ./src/scenes/DataTraffic/utils/useResponseAction.js